module.exports = __webpack_public_path__ + "static/UnboundWorldsApart0-772fc16b03f59703f7100b698e0329c8.webp";